<template>
  <section>
    <div class="container fullPage mt-5">
      <div class="row">
        <div class="col-md-4 col-md-offset-4 col-sm-8 col-sm-offset-2">
          <div>
            <div class="form__container">
              <h3 v-if="routeName === 'Signup'">Sign Up</h3>
              <h3 v-else>Login</h3>
              <form v-on:submit.prevent>
                <v-text-field
                  v-model="user.first_name"
                  v-if="routeName === 'Signup'"
                  color="black"
                  label="First Name"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="user.last_name"
                  v-if="routeName === 'Signup'"
                  color="black"
                  label="Last Name"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="user.email"
                  color="black"
                  label="Email"
                  required
                  type="email"
                ></v-text-field>
                <v-text-field
                  v-model="user.phone"
                  v-if="routeName === 'Signup'"
                  color="black"
                  type="number"
                  maxlength="10"
                  minlength="10"
                  label="Mobile Number"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="user.password"
                  type="password"
                  color="black"
                  required
                  label="Password"
                  hint="At least 8 characters"
                ></v-text-field>
                <button v-if="routeName === 'Login'" @click="login">
                  Login
                </button>
                <button v-else @click="signup">Signup</button>
              </form>
            </div>
            <div class="mt-3 link_section">
              <router-link
                to="/signup"
                class="subheading mt-3"
                v-if="routeName !== 'Signup'"
                >Don't have an account yet? Sign Up
              </router-link>
              <router-link to="/login" class="subheading mt-3" v-else
                >Already a user ? Login
              </router-link>
              <router-link to="/forgot-password" class="subheading mt-3">
                Forgot password
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email, numeric } from "vuelidate/lib/validators";
import lb from "../util/lb";

export default {
  name: "LoginSignup",
  mixins: [validationMixin],
  validations: {
    "user.first_name": { required },
    "user.last_name": { required },
    "user.email": { required, email },
    "user.phone": { numeric, required, maxLength: maxLength(10) },
    "user.password": { required }
  },
  data() {
    return {
      routeName: null,
      user: {
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        phone: null
      }
    };
  },
  created() {
    this.routeName = this.$route.name;
    if (window.localStorage.getItem("accesstoken")) {
      this.$router.push("/myaccount");
      return;
    }
    if (this.$route.query.source === "pricing") {
      this.$toasted.show("Please login to continue", {
        duration: 5000,
        position: "bottom-right"
      });
    }
    if (this.$route.query.source === "free_report") {
      this.$toasted.show(
        "You will receive a sample report at your email within 24 hours once you sign up.",
        {
          duration: 7000,
          position: "bottom-right"
        }
      );
    }
  },
  watch: {
    "$route.name"(newValue) {
      this.routeName = newValue;
    }
  },
  methods: {
    signup() {
      // if(validation){}
      lb.post("/api/GWSUsers", {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        phone: this.user.phone,
        password: this.user.password,
        admin: 0
      })
        .then(() => {
          return lb.post("/api/Messages/sendContactUsDetails", {
            contactInfo: {
              name: this.user.first_name + this.user.last_name,
              level: "New Signup",
              email: this.user.email,
              mobile: this.user.phone
            }
          });
        })
        .then(() => {
          this.$toasted.success(
            "Your account has been made. Please Login to continue",
            {
              duration: 3000,
              position: "bottom-right"
            }
          );
          if (this.$route.query.source === "pricing") {
            this.$router.push("/login?source=pricing");
            return;
          }
          this.$router.push("/login");
        })
        .catch(e => {
          this.$toasted.error("Oops some error occured!", {
            duration: 2000,
            position: "bottom-right"
          });
        });
    },
    login() {
      // if validation
      lb.post("/api/GWSUsers/login", {
        email: this.user.email,
        password: this.user.password
      })
        .then(({ data }) => {
          this.$store.commit("SET_ACCESS_TOKEN", data.id);
          window.localStorage.setItem("accesstoken", data.id);
          return data.userId;
        })
        .then(userId => {
          return lb.get(`/api/GWSUsers/${userId}`);
        })
        .then(({ data }) => {
          this.$store.commit("SET_CURRENT_USER", data);
          window.localStorage.setItem("user", JSON.stringify(data));
          if (this.$route.query.source === "pricing") {
            this.$router.push("/pricing#pricing_section");
            return;
          }
          this.$router.push("/myaccount");
        })
        .catch(e => {
          this.$toasted.error("Incorrect Credentials", {
            duration: 2000,
            position: "bottom-right"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.form__container {
  padding: 23px;
  h3 {
    text-align: center;
    background: #fff;
    position: relative;
    bottom: 45px;
  }
  border: 1px #31cc9a solid;
}
.link_section {
  text-align: left;
  a {
    display: block;
  }
}
button {
  color: #fff;
  font-weight: 700;
  background: #31cc9a;
  width: 100%;
  height: 50px;
  font-size: 1.5em;
}
.fullPage {
  min-height: 100vh;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
a {
  font-weight: 400;
  text-align: center;
  text-decoration: none;
  color: #31cc9a;
}
a:hover {
  color: #1a7055;
  text-decoration: none;
}
a:visited {
  color: #31cc9a;
}
/*==========  Mobile First Method  ==========*/

/* Custom, iPhone Retina */
@media only screen and (min-width: 320px) {
}

/* Extra Small Devices, Phones */
@media only screen and (min-width: 480px) {
}

/* Small Devices, Tablets */
@media only screen and (min-width: 768px) {
}

/* Medium Devices, Desktops */
@media only screen and (min-width: 992px) {
}

/* Large Devices, Wide Screens */
@media only screen and (min-width: 1200px) {
}

/*==========  Non-Mobile First Method  ==========*/

/* Large Devices, Wide Screens */
@media only screen and (max-width: 1200px) {
}

/* Medium Devices, Desktops */
@media only screen and (max-width: 992px) {
}

/* Small Devices, Tablets */
@media only screen and (max-width: 768px) {
}

/* Extra Small Devices, Phones */
@media only screen and (max-width: 480px) {
}

/* Custom, iPhone Retina */
@media only screen and (max-width: 320px) {
}
</style>



// WEBPACK FOOTER //
// src/views/LoginSignup.vue